import styled from '@emotion/styled';
import { useFormikContext } from 'formik';
import * as R from 'ramda';
import React, { useMemo } from 'react';
import { Col, Row, FormLabel, FormGroup, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

import useFetchAdminTherapyCategoriesQuery from 'App/hooks/useFetchAdminTherapyCategoriesQuery';
import { TextField } from 'Shared/form/TextField';
import SelectAllField from 'Shared/form/SelectAllField';

const StyledH4 = styled.h4`
    margin-bottom: 16px;
`;

const AddEditMedicationDetailsForm = ({ isEditMode = false }) => {
    const formik = useFormikContext();
    const { data: therapeuticCategories, isLoading: isFormLoading } = useFetchAdminTherapyCategoriesQuery();

    const allTherapies = useMemo(() => {
        if (therapeuticCategories && !isFormLoading) {
            return R.sortBy(R.prop('name'), R.values(therapeuticCategories));
        }
        return [];
    }, [therapeuticCategories, isFormLoading]);

    return (
        <>
            <StyledH4>Medication Details</StyledH4>
            <form onSubmit={(e) => e.preventDefault()}>
                <Row>
                    <Col md={4}>
                        <TextField
                            fieldName="stmMedicationName"
                            label="STM Medication Name"
                            placeholder="STM Medication Name"
                            required
                        />
                    </Col>
                    <Col md={4}>
                        <SelectAllField
                            fieldName="assignedTherapeuticCategories"
                            label="Assign Therapeutic Categories"
                            placeholder="Select therapeutic categories"
                            options={allTherapies}
                            triggerPropValue="all"
                            getOptionValue={R.prop('id')}
                            getOptionLabel={R.prop('name')}
                            required
                            isLoading={isFormLoading}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <FormLabel>
                                <strong>Assigned GPI10:</strong>
                            </FormLabel>
                            <p>
                                <strong>{formik.values.gpi10}</strong>
                                {!isEditMode && formik.values.gpi10 && (
                                    <Button
                                        variant="link"
                                        style={{ marginLeft: 8, padding: 0 }}
                                        onClick={() => formik.setFieldValue('gpi10', '')}
                                        data-testid="details-unassign-gpi10-btn"
                                    >
                                        Unassign
                                    </Button>
                                )}
                            </p>
                        </FormGroup>
                    </Col>
                </Row>
            </form>
        </>
    );
};

AddEditMedicationDetailsForm.propTypes = {
    isEditMode: PropTypes.bool,
};

AddEditMedicationDetailsForm.defaultProps = {
    isEditMode: false,
};

export default AddEditMedicationDetailsForm;
